import React from 'react'

const ArnoldLogo: React.FC = () => {
    return <img src="/arnold-logo.svg" alt="Arnold logo" height="30" />
}

export default ArnoldLogo
